import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { theme } from "../theme.js";
import Button from "./base/Button.jsx";

export default function ProfileHeader({ participant }) {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("participant");
    navigate("/login");
  };

  // Handle case where participant is null
  if (!participant) {
    return (
      <div style={{ ...styles.profileHeader, flexDirection: isMobile ? "column" : "row", alignItems: isMobile ? "flex-start" : "center" }}>
        <div style={styles.profileInfo}>
          <div style={styles.avatar}>?</div>
          <div>
            <h1 style={styles.name}>Profil</h1>
            <p style={styles.infos}>Chargement...</p>
          </div>
        </div>
        <div style={{ marginRight: isMobile ? 0 : theme.spacing.lg, width: isMobile ? "100%" : "auto" }}>
          <Button title="Déconnexion" onClick={handleLogout} width={isMobile ? "100%" : "150px"} />
        </div>
      </div>
    );
  }

    return(  
    <div style={{ ...styles.profileHeader, flexDirection: isMobile ? "column" : "row", alignItems: isMobile ? "flex-start" : "center" }}>
        <div style={styles.profileInfo}>
            <div style={styles.avatar}>
                {participant.firstname?.charAt(0)}{participant.lastname?.charAt(0)}
            </div>
            <div>
                <h1 style={styles.name}>{participant.firstname} {participant.lastname || participant.name}</h1>
                <p style={styles.infos}>{participant.email}</p>
            </div>
        </div>
        <div style={{ marginRight: isMobile ? 0 : theme.spacing.lg, width: isMobile ? "100%" : "auto" }}>
          <Button title="Déconnexion" onClick={handleLogout} width={isMobile ? "100%" : "150px"} />
        </div>
    </div>
    )
};

const styles = {
  profileHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `${theme.spacing.xxxl} 0`,
    marginBottom: theme.spacing.lg,
    gap: theme.spacing.lg,
    width: "100%",
  },
  profileInfo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.lg,
  },
  avatar: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    background: `linear-gradient(135deg, ${theme.colors.light} 0%, ${theme.colors.dark} 100%)`,
    color: theme.colors.white,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: theme.fonts.size.xxl,
    fontWeight: theme.fonts.weight.light,
    textTransform: "uppercase",
    fontFamily: theme.fonts.family.logo,
    marginLeft: theme.spacing.lg,
  },
  name: {
    fontSize: theme.fonts.size.xxl,
    fontWeight: theme.fonts.weight.semibold,
    margin: 0,
    color: theme.colors.textInverted,
  },
  infos: {
    fontSize: theme.fonts.size.base,
    color: theme.colors.textInverted,
    margin: `${theme.spacing.xs} 0 0 0`,
    display: "flex",
  },
  infoList: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xs,
  },
  label: {
    fontWeight: theme.fonts.weight.semibold,
    minWidth: 160,
    display: "inline-block",
  },
  value: {
    fontWeight: theme.fonts.weight.normal,
  },
};